export default "__VITE_ASSET__FxXbGcpK__"